export enum BookingSortTypes {
	createdAt = 1,
	clientName = 2,
	candidateName = 3,
}
